export const customGetGeoCodeFromAddress = (address: string) =>
    new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        if (address && address.trim()) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address, componentRestrictions: { country: "US" } }, (results: google.maps.GeocoderResult[] | null, status: any) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results || []);
                } else {
                    reject(status);
                }
            });
        } else {
            reject(google.maps.GeocoderStatus.ZERO_RESULTS);
        }
    });
